import React from 'react';
import { useLicencia } from '../context/LicenciaContext';

// ── Datos de transferencia ── actualiza estos valores con tu cuenta real
const DATOS_TRANSFERENCIA = {
    banco: 'Itaú',
    tipo: 'Cuenta Corriente',
    numero: '0224857357',
    rut: '77.380.106-1',
    nombre: 'E-Softlab SpA',
    email: 'ehidalgo@komity.cl',
};

const WHATSAPP = '+56920039433';

export default function ModalLicencia() {
    const { estado, diasGracia, fechaVencimiento, mostrarModal, cerrarModal } = useLicencia();

    if (!mostrarModal || estado !== 'WARNING') return null;

    const esUltimoDia = diasGracia === 0;

    const fmtFecha = (iso) => {
        if (!iso) return null;
        try {
            const [y, m, d] = iso.split('-');
            return `${d}/${m}/${y}`;
        } catch { return iso; }
    };

    const msgWsp = encodeURIComponent(
        `Hola Komity, quiero regularizar el pago de mi suscripción. Mi sistema venció el ${fmtFecha(fechaVencimiento) || 'fecha no disponible'}.`
    );

    return (
        <div
            style={{
                position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
                backgroundColor: 'rgba(0,0,0,0.65)', zIndex: 99998,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                backdropFilter: 'blur(4px)'
            }}
            onClick={cerrarModal}
        >
            <div
                style={{
                    backgroundColor: 'white', borderRadius: '24px', padding: '36px',
                    maxWidth: '460px', width: '92%',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
                    maxHeight: '90vh', overflowY: 'auto'
                }}
                onClick={e => e.stopPropagation()}
            >
                {/* Cabecera */}
                <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                    <div style={{
                        width: '72px', height: '72px', borderRadius: '50%',
                        backgroundColor: '#fffbeb', border: '3px solid #f59e0b',
                        display: 'flex', flexDirection: 'column',
                        alignItems: 'center', justifyContent: 'center',
                        margin: '0 auto 16px'
                    }}>
                        <span style={{ fontSize: '26px', fontWeight: 900, color: '#f59e0b', lineHeight: 1 }}>
                            {diasGracia}
                        </span>
                        <span style={{ fontSize: '9px', color: '#f59e0b', fontWeight: 700, marginTop: '2px' }}>
                            {diasGracia === 1 ? 'DÍA' : 'DÍAS'}
                        </span>
                    </div>

                    <h2 style={{ fontWeight: 800, fontSize: '1.3rem', margin: '0 0 6px', color: '#92400e' }}>
                        Pago pendiente
                    </h2>

                    <p style={{ color: '#b45309', fontSize: '13px', margin: 0 }}>
                        {fechaVencimiento
                            ? <>Tu plan venció el <strong>{fmtFecha(fechaVencimiento)}</strong>.</>
                            : 'Tu plan ha vencido.'
                        }
                        {' '}
                        {esUltimoDia
                            ? <span style={{ color: '#ef4444', fontWeight: 700 }}>Hoy es el último día de gracia.</span>
                            : <>Te quedan <strong>{diasGracia} días</strong> antes del bloqueo.</>
                        }
                    </p>
                </div>

                {/* Datos de transferencia */}
                <div style={{
                    backgroundColor: '#f8fafc', borderRadius: '14px',
                    border: '1px solid #e2e8f0', padding: '18px',
                    marginBottom: '20px'
                }}>
                    <p style={{ fontSize: '11px', fontWeight: 700, color: '#64748b', margin: '0 0 12px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                        Datos para transferencia
                    </p>
                    {[
                        { label: 'Banco', value: DATOS_TRANSFERENCIA.banco },
                        { label: 'Tipo', value: DATOS_TRANSFERENCIA.tipo },
                        { label: 'N° cuenta', value: DATOS_TRANSFERENCIA.numero },
                        { label: 'RUT', value: DATOS_TRANSFERENCIA.rut },
                        { label: 'Nombre', value: DATOS_TRANSFERENCIA.nombre },
                        { label: 'Email', value: DATOS_TRANSFERENCIA.email },
                    ].map(({ label, value }) => (
                        <div key={label} style={{
                            display: 'flex', justifyContent: 'space-between',
                            padding: '6px 0',
                            borderBottom: '1px solid #e2e8f0'
                        }}>
                            <span style={{ fontSize: '12px', color: '#94a3b8' }}>{label}</span>
                            <span style={{ fontSize: '12px', fontWeight: 600, color: '#1e293b' }}>{value}</span>
                        </div>
                    ))}
                    <p style={{ fontSize: '11px', color: '#94a3b8', margin: '10px 0 0', textAlign: 'center' }}>
                        Incluye el nombre de tu negocio en el comentario de la transferencia
                    </p>
                </div>

                {/* Botones */}
                <a
                    href={`https://wa.me/${WHATSAPP}?text=${msgWsp}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        display: 'block', width: '100%', padding: '13px',
                        background: '#25d366', color: '#fff', textDecoration: 'none',
                        borderRadius: '12px', fontSize: '14px', fontWeight: 700,
                        textAlign: 'center', marginBottom: '10px', boxSizing: 'border-box'
                    }}
                >
                    Avisar pago por WhatsApp
                </a>

                <button
                    onClick={cerrarModal}
                    style={{
                        width: '100%', padding: '12px',
                        background: 'transparent', color: '#94a3b8',
                        border: '1px solid #e2e8f0', borderRadius: '12px',
                        fontSize: '13px', cursor: 'pointer'
                    }}
                >
                    Cerrar — aviso luego
                </button>
            </div>
        </div>
    );
}
